import FormatDigital from './format-digital.element.js';

export default FormatDigital;

FormatDigital.define('wje-format-digital', FormatDigital);
